/**
 * Merges extra parameters from the "state" query parameter into the URL.
 * @returns The new URL string with merged parameters, or the original URL if no state parameter exists
 */
export function mergeStateParamsIntoUrl(urlString: string): string {
  const url = new URL(urlString);
  const state = url.searchParams.get('state');

  if (!state) {
    return urlString;
  }

  const stateObj = JSON.parse(state) as Record<string, string>;
  const newParams = new URLSearchParams(url.searchParams);

  for (const [key, value] of Object.entries(stateObj)) {
    newParams.set(key, value);
  }

  url.search = newParams.toString();
  return url.toString();
}
